// src/datastores/offline-datastore/validate-offline-datastore.ts
function validateOfflineDatastore(possibleDatastore) {
  const validDatastore = { contexts: {}, events: [] };
  if (!possibleDatastore.contexts && !possibleDatastore.events) {
    return validDatastore;
  }
  if (possibleDatastore.contexts && typeof possibleDatastore.contexts === "object") {
    Object.entries(possibleDatastore.contexts).forEach(
      ([contextId, context]) => {
        if (context.status && context.data && typeof context.data === "object" && context.data.app_version && context.data.application_id && context.data.client_id && context.data.device && context.data.session_id) {
          validDatastore.contexts[contextId] = context;
        }
      }
    );
  }
  if (possibleDatastore.events && typeof possibleDatastore.events === "object" && Array.isArray(possibleDatastore.events)) {
    possibleDatastore.events.forEach((event) => {
      if (event && event.contextId && validDatastore.contexts[event.contextId] && event.status && event.data && typeof event.data === "object" && event.data._type && event.data.created && event.data.createdMicros) {
        validDatastore.events.push(event);
      }
    });
  }
  return validDatastore;
}

export {
  validateOfflineDatastore
};
